@if (!submitted && validatePasswordResetResponse) {
<app-rp-edit
  [validatePasswordResetResponse]="validatePasswordResetResponse"
  [headerToken]="headerToken"
  (resetPasswordOutput)="getresetPasswordSuccessData($event)"
></app-rp-edit>
} @if (submitted) {
<app-rp-confirmation></app-rp-confirmation>
}
